var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4241_11586)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E2EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9023 29.7646C36.9748 32.3437 36.8329 35.1529 37.4876 37.824C38.1642 40.4721 38.5897 40.3915 42.3215 41.6465C41.0449 45.1926 35.829 49.0611 32.37 49.1187C29.2492 49.1763 20.5307 44.9739 18.9812 42.0034C20.738 41.8307 25.9975 40.9787 26.9905 38.3306C28.1908 35.1299 27.0887 32.1594 26.7177 30.6512L37.9023 29.7646Z",
    fill: "#FFDEB3",
    stroke: "#2D2D2D",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9156 64.7297C44.984 64.7182 54.5755 62.0241 55.9613 60.2971C57.5326 58.3283 51.7712 47.2524 50.0908 44.9036C50.0908 44.9036 48.454 42.1289 39.3645 40.54C38.557 43.073 35.7745 44.8115 32.1736 44.8691C28.6272 44.9382 25.0918 43.2342 24.1861 40.7358C15.3476 42.1865 12.5869 44.9036 11.8231 46.7688C11.4739 47.6323 7.02187 55.9795 7.00005 59.2608C6.96731 63.1178 22.9531 64.7412 32.9156 64.7297Z",
    fill: "#FFABAF",
    stroke: "#2D2D2D",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9287 22.4062C42.1361 22.4178 44.242 22.5559 44.8204 23.8915C45.4314 25.2846 44.3184 27.8866 41.4595 29.1416C42.0597 26.9425 42.2234 24.6514 41.9287 22.4062Z",
    fill: "#FFDEB3",
    stroke: "#2D2D2D",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4948 22.2695C22.2875 22.281 20.1815 22.4192 19.6032 23.7548C18.9921 25.1479 20.1051 27.7499 22.964 29.0049C22.3529 26.8173 22.2002 24.5262 22.4948 22.2695Z",
    fill: "#FFDEB3",
    stroke: "#2D2D2D",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0147 24.1688C22.1456 26.4254 22.4184 31.0077 25.6156 34.8532C26.7941 36.2694 28.9764 38.8829 32.1627 38.8944C35.4471 38.9059 37.7059 36.1542 38.8407 34.7611C41.8633 31.0653 42.1361 26.7478 42.3107 24.1803C42.5616 20.3463 42.8562 15.9136 39.8882 12.6323C37.8259 10.5138 35.0325 9.37401 32.1627 9.46612C29.0419 9.65033 26.1394 11.1816 24.1207 13.6915C21.5891 17.0074 21.8183 20.8299 22.0147 24.1688Z",
    fill: "#FFDEB3",
    stroke: "#2D2D2D",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5657 21.5209C28.9982 21.4863 28.4417 21.5324 27.8852 21.659C27.3833 21.7857 26.8923 21.9699 26.434 22.2347",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5657 21.5209C28.9982 21.4863 28.4417 21.5324 27.8852 21.659C27.3833 21.7857 26.8923 21.9699 26.434 22.2347",
    stroke: "#2D2D2D",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9234 21.5213C36.0036 21.4522 37.0948 21.694 38.055 22.2351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9234 21.5213C36.0036 21.4522 37.0948 21.694 38.055 22.2351",
    stroke: "#2D2D2D",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.409 25.2972C28.8489 25.2972 29.2056 24.9209 29.2056 24.4567C29.2056 23.9925 28.8489 23.6162 28.409 23.6162C27.9691 23.6162 27.6124 23.9925 27.6124 24.4567C27.6124 24.9209 27.9691 25.2972 28.409 25.2972Z",
    fill: "#474748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0036 25.2972C36.4435 25.2972 36.8002 24.9209 36.8002 24.4567C36.8002 23.9925 36.4435 23.6162 36.0036 23.6162C35.5637 23.6162 35.207 23.9925 35.207 24.4567C35.207 24.9209 35.5637 25.2972 36.0036 25.2972Z",
    fill: "#474748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1151 28.9697C31.4425 29.2921 31.879 29.4533 32.3263 29.4187C32.6646 29.3842 32.992 29.223 33.232 28.9697",
    stroke: "#2D2D2D",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4783 32.124C30.2858 32.93 31.377 33.3444 32.4791 33.2523C33.3302 33.1602 34.1268 32.7573 34.7378 32.124",
    stroke: "#2D2D2D",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.384 30.5468C30.9733 30.6735 31.5734 30.7541 32.1736 30.8116C33.1229 30.8116 33.3084 30.5468 34.0504 30.5468C35.1634 30.5583 36.3637 31.1455 36.3419 31.5485C36.3092 32.1126 33.8103 32.4235 32.1081 32.435C30.2204 32.4465 27.6452 32.1011 27.6234 31.5485C27.5906 31.1225 29.0419 30.4662 30.384 30.5468Z",
    fill: "#474748",
    stroke: "#2D2D2D",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1002 13.8756C45.7806 19.1718 42.5507 24.8018 41.7214 24.6522C41.1867 24.5601 41.6996 22.1077 40.0955 19.0221C39.4736 17.8247 38.6552 16.2474 37.193 15.8329C35.6108 15.3723 34.9015 16.7194 32.1845 17.5599C28.6709 18.6422 27.4924 15.6487 25.5392 16.8461C22.6476 18.6076 23.2259 24.5946 22.1675 24.6061C20.989 24.6061 18.7521 18.9415 20.4652 13.8756C21.6764 10.7209 24.0661 8.23403 27.0778 7.01361C29.8166 5.82773 32.861 5.67805 35.6981 6.58761C36.9529 6.95604 42.4416 8.60246 44.1002 13.8756Z",
    fill: "#474748",
    stroke: "#2D2D2D",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4241_11586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIcon);
export default __webpack_public_path__ + "static/media/MaleIcon.8671a75ab44682657898ca1d3627ac6b.svg";
export { ForwardRef as ReactComponent };